import React, { useState } from "react";
import Hero from "../../components/Hero/Hero";
import { imgOfficeOnMap } from "../../assets/imgExport";
import { IconEmail2, IconLocation2 } from "../../assets/svgExport";
import GetInTouch from "../../components/GetInTouch/GetInTouch";

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [alertMsg, setAlertMsg] = useState("");

  function HeroSection() {
    return (
      // <Hero
      //   title="Contact"
      //   content="We would love to discuss how Venti Maris can support your project. "
      // />
      <div className="hero-container">
        <p className="">Get in touch</p>
        <h1>Contact us</h1>
        <p className="paragraph">
          We would love to discuss how Venti Maris can support your project.
        </p>
      </div>
    );
  }

  function ContactInfoSection() {
    const contactInfo = [
      {
        icon: <IconLocation2 width={24} height={24} />,
        title: "Address",
        content: "5 South Charlotte Street, Edinburgh, Scotland, EH2 4AN",
      },
      {
        icon: <IconEmail2 width={24} height={20} />,
        title: "Email",
        content: "contact@ventimaris.com",
      },
    ];
    return (
      <div className="flex flex-col mobile:flex-row border-y justify-between">
        <div className="flex flex-col justify-between gap-8 px-10 sm:px-20 py-8">
          <p className="text-secondary-main text-lg mb-4">
            Feel free to reach out to us through the following channels:
          </p>
          <ul>
            {contactInfo.map((info, idx) => {
              return (
                <li key={idx} className="flex gap-2 items-center mt-4">
                  {info.icon}
                  {info.title === "Email" ? (
                    <p>
                      <span className="font-bold text-main">
                        {info.title}:&nbsp;
                      </span>
                      <a href={"mailto:" + info.content}>{info.content}</a>
                    </p>
                  ) : (
                    <p>
                      <span className="font-bold text-main">
                        {info.title}:&nbsp;
                      </span>
                      {info.content}
                    </p>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
        <img
          className="w-full mobile:w-[30vw] border-t object-cover"
          src={imgOfficeOnMap}
          alt="a map points to the office"
        />
        {/* <img className="w-full mobile:w-[30vw] border-t object-cover" src={imgOfficeOnMap} alt="a map points to the office" /> */}
      </div>
    );
  }

  function ContactFormIntroSection() {
    return (
      <p className="text-secondary-main text-lg">
        Or, simply send us a message using the contact form below and our team
        will get back to you promptly:
      </p>
    );
  }

  function ContactFormFieldsSection() {
    function handleSubmit(event: React.FormEvent) {
      event.preventDefault();
      if (!name.trim()) {
        setAlertMsg("Please provide your name.");
        return;
      }

      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(email)) {
        setAlertMsg("Please provide a valid email address.");
        return;
      }

      // Empty submit function
    }

    return (
      <form onSubmit={handleSubmit} className="bg-white  mt-10">
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="name"
          >
            Name:
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
            }}
            placeholder="Your Name"
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="email"
          >
            Email:
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            placeholder="Your Email Address"
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="mb-6">
          <label
            className="block text-gray-700 text-sm font-bold mb-2"
            htmlFor="message"
          >
            Message:
          </label>
          <textarea
            id="message"
            name="message"
            value={message}
            onChange={(e) => {
              setMessage(e.target.value);
            }}
            placeholder="How can we help? Please include some details about your inquiry or project."
            required
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline h-32"
          />
        </div>
        {alertMsg && <p className="text-red-800">{alertMsg}</p>}
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-main hover:bg-secondary-main text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
          >
            Submit
          </button>
        </div>
        <p className="text-sm text-gray-500 mt-4">
          (All information you provide is kept confidential. We aim to respond
          to all inquiries within one business day.)
        </p>
      </form>
    );
  }

  function ClosingSection() {
    return (
      <div className="bg-main/5 py-16 px-12 text-center flex flex-col items-center">
        <p className="text-lg text-secondary-dark mb-6">
          We look forward to connecting with you and exploring how our heavy
          marine transport solutions can contribute to your offshore renewable
          energy goals.
        </p>
      </div>
    );
  }

  return (
    <div>
      <HeroSection />
      <ContactInfoSection />
      {/* <div className="main-contanet-div">
        <ContactFormIntroSection />
        <ContactFormFieldsSection />
      </div> */}
      {/* <GetInTouch /> */}
      {/* <ClosingSection /> */}
    </div>
  );
}
